import styled from "styled-components";

export const Container = styled.div` 
  min-width: 1280px; 
  background: #FFFFFF 0% 0% no-repeat padding-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 1;

  @media (max-width: 768px){
    min-width: 100%; 
  }

`;

export const MaxWidth = styled.div`
  width: 100%;
  max-width: 1080px;
  min-height: 80px; 
  margin: 0px 100px; 
  display: flex;
  align-items: center;
  @media (max-width: 768px){
    max-width: 100%;
    margin: 6px; 
    min-height: 66px; 
  }  
`;

export const Logo = styled.img`
  width: 68px;
  height: 68px;
  object-fit: cover;
`;

export const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const BackIcon = styled.img``;

export const ButtonText = styled.p`
  font-weight: bold;
`;